import React, { PureComponent } from 'react';
import { Banner } from '@spotify-internal/encore-creator-web';
import styled, { keyframes } from 'styled-components';

const alertKeyframes = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: 48px;
  }
`;

const StyledAlert = styled.div`
  margin-bottom: 16px;
  overflow: hidden;
  animation-name: ${alertKeyframes};
  animation-duration: 0.3s;
  animation-timing-function: ease;
  animation-delay: 0s;
`;

type Props = {
  variant?: string;
  message: React.ReactNode;
  style?: React.CSSProperties;
};

export class AnimatedAlert extends PureComponent<Props> {
  static defaultProps = {
    variant: Banner.error,
  };

  render() {
    const { variant, message, style } = this.props;
    return (
      <StyledAlert style={style}>
        <Banner variant={variant}>{message}</Banner>
      </StyledAlert>
    );
  }
}
